angular.module('impactx.rfx').controller('RFXSupplierListCtrl', [
    'selectedListItems',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    '$redirect',
    'ConfirmationService',
    'dataGen',
    '$scope',
    RFXSupplierListCtrl
]);

function RFXSupplierListCtrl(selectedListItems, $mdDialog, ToastService, TranslationService, $redirect, ConfirmationService,
                             dataGen, $scope) {
    var self = this;
    self.$onInit = function() {
        self.conversation = $scope.trns.conversation;
        self.unreadConversation = $scope.trns.unreadConversation;
    }

    this.canView = function () {
        return selectedListItems.isSingleSelection();
    };

    this.getViewLink = function () {
        return selectedListItems.getFirstSelectedItem().directEditJump == 1 ?
            "rfxsupplier/edit/" + selectedListItems.getFirstSelectedItem().id :
            "rfxsupplier/view/" + selectedListItems.getFirstSelectedItem().id;
    };

    self.getDetailLink = function () {
        return 'rfxsupplier/edit/' + selectedListItems.getFirstSelectedItem().id;
    };

    self.canViewOffer = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().directEditJump != 1 &&
            impactX.isDefined(selectedListItems.getFirstSelectedItem(), "canViewOffer.value");
    }

    self.canEditOffer = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().directEditJump != 1 &&
            impactX.isDefined(selectedListItems.getFirstSelectedItem(), "canEditOffer.value") &&
            !impactX.isDefined(selectedListItems.getFirstSelectedItem(), "canViewOffer.value");
    }

    this.createRFQH = function (event) {
        $mdDialog.show({
            controller: "RFXRFQHFromSupplierCreationCtrl",
            controllerAs: "rfxRfqhFromSupplierCreationCtrl",
            templateUrl: "modules/rfxsupplier/templates/rfqfromsuppliercreation.dialog.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false
        });
    };

    self.canDeleteRFQS = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDeleteRFQS.value;
    }

    self.deleteRFQS = function (event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {rfqsId: selectedListItems.getFirstSelectedId()}, "/rfx/supplier/delete").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                $redirect.reload();
            });
        }, event, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getViewLink,
            type: 'link',
            condition: self.canView,
            process: 'RFXSupplierView'
        },
        {
            label: "viewOffer",
            linkFunction: self.getDetailLink,
            type: 'link',
            process: 'RFXSupplierView',
            condition: self.canViewOffer
        },
        {
            label: "editOffer",
            linkFunction: self.getDetailLink,
            type: 'link',
            process: 'RFXSupplierView',
            condition: self.canEditOffer
        },
        {
            label: "delete",
            type: 'dialogaction',
            process: 'RFXSupplierEdit',
            action: self.deleteRFQS,
            condition: self.canDeleteRFQS
        }
    ];

    this.meta = {
        rowTemplate: 'modules/rfxsupplier/templates/rfxsupplierlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/supplier/list',
        id: "rfxsupplierlist",
        buttonDefinition: buttonDefinition,
        mainActionFunction: {id: "newRFQHSupplier", action: this.createRFQH, icon: "mdi-plus"}
    };

    this.getMeta = function () {
        return this.meta;
    };
}